<template>
  <b-container>
    <m-categories-wrapper :single-category="category">
      <template slot-scope="{categories,imageHandler,setLinkType}">
        <swiper ref="mySwiper" :options="swiperOptions">

          <swiper-slide v-for="category in categories[0].children" :key="category.id">


            <m-a :href="{name:'SingleCategory',params:{slug:category.slug}}">
              <img
                  class="card-img-top cover border-rounded"
                  :src="category.image"
                  :alt="category.alt"
              />
            </m-a>

          </swiper-slide>

          <div class="swiper-pagination" slot="pagination"></div>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
      </template>
    </m-categories-wrapper>
  </b-container>
</template>

<script>
import {Swiper, SwiperSlide, directive} from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default {
  name: "Slider-1",
  components: {Swiper, SwiperSlide, directive},
  props:{
    category:{
      default:'header-slider'
    }
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 1,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          dynamicBullets: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  mounted() {
  },
};
</script>

<style scoped>
.card-img-top {
  border-radius: 10px;
  max-height: 530px;
  min-height: 200px;
}

.card {
  border-radius: 10px;
  height: 100%;
}

.slider-row {
  max-height: 530px;
  min-height: 200px;
  margin-bottom: 20px;
}

.cover {
  object-fit: contain;
}
</style>